import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RoutesLink } from "../ApiHelper/RoutesLink";
import GeneralExpenseHead from "../Pages/Accounts/AccountSettings/GeneralExpenseHead/GeneralExpenseHead";
import CustomerLedger from "../Pages/Accounts/CustomerLedger/CustomerLedger";
import CustomerLedgerDetail from "../Pages/Accounts/CustomerLedger/CustomerLedgerDetail";
import DayBook from "../Pages/Accounts/DayBook/DayBook";
import ExpenseHead from "../Pages/Accounts/ExpenseHead/ExpenseHead";
import CreateInvoice from "../Pages/Accounts/Invoice/CreateInvoice";
import Invoice from "../Pages/Accounts/Invoice/Invoice";
import InvoiceDetail from "../Pages/Accounts/Invoice/InvoiceDetail";
import PaymentOverview from "../Pages/Accounts/PaymentOverview";
import CreateAgainstPO from "../Pages/Accounts/PaymentTickets/CreateAgainstPO";
import CreateGeneral from "../Pages/Accounts/PaymentTickets/CreateGeneral";
import PaymentTicketAgainsPo from "../Pages/Accounts/PaymentTickets/PaymentTicketAgainsPo";
import PaymentTicketDetails from "../Pages/Accounts/PaymentTickets/PaymentTicketDetails";
import PaymentTicketGeneral from "../Pages/Accounts/PaymentTickets/PaymentTicketGeneral";
import PurchaseOrder from "../Pages/Accounts/PurchaseOrder/PurchaseOrder";
import PurchaseOrderDetail from "../Pages/Accounts/PurchaseOrder/PurchaseOrderDetail";
import CreateSalaryTicket from "../Pages/Accounts/SalaryTickets/CreateSalaryTicket";
import SalaryTicketDetails from "../Pages/Accounts/SalaryTickets/SalaryTicketDetail";
import SalaryTickets from "../Pages/Accounts/SalaryTickets/SalaryTickets";
import TdsDetail from "../Pages/Accounts/TDS/TdsDetail";
import TdsLedger from "../Pages/Accounts/TDS/TdsLedger";
import VendorLedger from "../Pages/Accounts/VendorLedger/VendorLedger";
import VendorLedgerDetail from "../Pages/Accounts/VendorLedger/VendorLedgerDetail";
import AddWorkOrder from "../Pages/Accounts/WorkOrder/AddWorkOrder";
import WorkOrder from "../Pages/Accounts/WorkOrder/WorkOrder";
import WorkOrderDetail from "../Pages/Accounts/WorkOrder/WorkOrderDetail";
import ForgetPassword from "../Pages/Auth/ForgetPassword";
import Login from "../Pages/Auth/Login";
import NewPassword from "../Pages/Auth/NewPassword";
import ProtectedDepartmentRoute from "../Pages/Auth/ProtectedDepartmentRoute";
import ProtectedLoginRoute from "../Pages/Auth/ProtectedLoginRoute";
import ProtectedRoute from "../Pages/Auth/ProtectedRoute";
import VerifyOtp from "../Pages/Auth/VerifyOtp";
import Forbidden403 from "../Pages/CommonPages/Forbidden403";
import NoInternet from "../Pages/CommonPages/NoInternet";
import UnderDevelopmentPage from "../Pages/CommonPages/UnderDevelopmentPage";
import UnderMaintenancePage from "../Pages/CommonPages/UnderMaintainancePage";
import Dashboard from "../Pages/Dashboard/Dashboard";
import OperationsCenter from "../Pages/OperationsCenter/OperationsCenter";
import AdminArRequest from "../Pages/HRM/AR_Regularization/AdminArRequest";
import ArRequestDetail from "../Pages/HRM/AR_Regularization/ArRequestDetail";
import TeamAR from "../Pages/HRM/AR_Regularization/TeamAR";
import UserAr from "../Pages/HRM/AR_Regularization/UserAr";
import AttendanceAdmin from "../Pages/HRM/Attendance/AttendanceAdmin";
import AttendanceSummary from "../Pages/HRM/Attendance/AttendanceSummary";
import AttendanceUser from "../Pages/HRM/Attendance/AttendanceUser";
import TeamAttendance from "../Pages/HRM/Attendance/TeamAttendance";
import ExtraWork from "../Pages/HRM/ExtraWork/ExtraWork";
import ExtraWorkUser from "../Pages/HRM/ExtraWork/ExtraWorkUser";
import TeamExtraWork from "../Pages/HRM/ExtraWork/TeamExtraWork";
import AddEmployeeOnBoard from "../Pages/HRM/HrmSettings/EmployeeOnBoard/AddEmployeeOnBoard";
import EmployeeDetail from "../Pages/HRM/HrmSettings/EmployeeOnBoard/EmployeeDetail";
import EmployeeOnBoard from "../Pages/HRM/HrmSettings/EmployeeOnBoard/EmployeeOnBoard";
import EmployeeTransfer from "../Pages/HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeTransfer";
import Holiday from "../Pages/HRM/HrmSettings/Holiday/Holiday";
import AddLeaveSetting from "../Pages/HRM/HrmSettings/LeaveSetting/AddLeaveSetting";
import LeaveSetting from "../Pages/HRM/HrmSettings/LeaveSetting/LeaveSetting";
import AddOffice from "../Pages/HRM/HrmSettings/OfficeLocation/AddOffice";
import OfficeLocation from "../Pages/HRM/HrmSettings/OfficeLocation/OfficeLocation";
import AddSalaryHead from "../Pages/HRM/HrmSettings/SalaryHead/AddSalaryHead";
import SalaryHead from "../Pages/HRM/HrmSettings/SalaryHead/SalaryHead";
import AddShiftAndTime from "../Pages/HRM/HrmSettings/ShiftAndTime/AddShiftAndTime";
import ShiftAndTimeConfig from "../Pages/HRM/HrmSettings/ShiftAndTime/ShiftAndTimeConfig";
import AdminLeaveRequest from "../Pages/HRM/Leave/AdminLeaveRequest";
import LeaveDetail from "../Pages/HRM/Leave/LeaveDetail";
import MyLeave from "../Pages/HRM/Leave/MyLeave";
import TeamLeave from "../Pages/HRM/Leave/TeamLeave";
import AddOdRequest from "../Pages/HRM/OutDoorDutyRequest/AddOdRequest";
import AdminOdRequest from "../Pages/HRM/OutDoorDutyRequest/AdminOdRequest";
import AdminOdRequestDetail from "../Pages/HRM/OutDoorDutyRequest/AdminOdRequestDetail";
import TeamOd from "../Pages/HRM/OutDoorDutyRequest/TeamOd";
import UserOd from "../Pages/HRM/OutDoorDutyRequest/UserOd";
import AdminWfhRequest from "../Pages/HRM/WfhRequest/AdminWfhRequest";
import MyWfh from "../Pages/HRM/WfhRequest/MyWfh";
import TeamWfh from "../Pages/HRM/WfhRequest/TeamWfh";
import MyPaySlip from "../Pages/HRM/PaySlip/MyPayslip";
import PaySlip from "../Pages/HRM/PaySlip/PaySlip";
import Notifications from "../Pages/Notifications/Notifications";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import UpdateProfile from "../Pages/Profile/UpdateProfile";
import UserProfile from "../Pages/Profile/UserProfile";
import AddSite from "../Pages/Sites/AddSite";
import BudgetLogs from "../Pages/Sites/BudgetRequests/BudgetLogs";
import BudgetRequests from "../Pages/Sites/BudgetRequests/BudgetRequests";
import CreateBudgetRequest from "../Pages/Sites/BudgetRequests/CreateBudgetRequest";
import AddCompany from "../Pages/Sites/Company/AddCompany";
import Company from "../Pages/Sites/Company/Company";
import CompanyDetail from "../Pages/Sites/Company/CompanyDetail";
import AddCustomer from "../Pages/Sites/Customers/AddCustomer";
import CustomerDetail from "../Pages/Sites/Customers/CustomerDetail";
import Customers from "../Pages/Sites/Customers/Customers";
import AddSiteSalaryHead from "../Pages/Sites/O&M/AddSiteSalaryHead";
import SiteSalaryHead from "../Pages/Sites/O&M/SiteSalaryHead";
import SitesOandM from "../Pages/Sites/O&M/SitesOandM";
import SitesProject from "../Pages/Sites/Projects/SitesProject";
import SiteDetail from "../Pages/Sites/SiteDetail";
import Assets from "../Pages/Sites/SiteSettings/Assets";
import CreateGRN from "../Pages/SupplyChain/GRN/CreateGRN";
import GRN from "../Pages/SupplyChain/GRN/GRN";
import GrnDetail from "../Pages/SupplyChain/GRN/GrnDetail";
import ItemMaster from "../Pages/SupplyChain/ItemSettings/ItemMaster";
import AddMachinery from "../Pages/SupplyChain/Machinery/AddMachinery";
import Machinery from "../Pages/SupplyChain/Machinery/Machinery";
import MachineryDetails from "../Pages/SupplyChain/Machinery/MachineryDetails";
import CreatePurchase from "../Pages/SupplyChain/Purchase/CreatePurchase";
import Purchase from "../Pages/SupplyChain/Purchase/Purchase";
import CreatePurchaseRequest from "../Pages/SupplyChain/PurchaseRequest/CreatePurchaseRequest";
import PurchaseRequest from "../Pages/SupplyChain/PurchaseRequest/PurchaseRequest";
import PurchaseRequestDetails from "../Pages/SupplyChain/PurchaseRequest/PurchaseRequestDetail";
import ServiceList from "../Pages/SupplyChain/SCMSetting/Service/ServiceList";
import AddVendor from "../Pages/SupplyChain/SCMSetting/Vendor/AddVendor";
import VendorDetail from "../Pages/SupplyChain/SCMSetting/Vendor/VendorDetail";
import VendorList from "../Pages/SupplyChain/SCMSetting/Vendor/VendorList";
import Stock from "../Pages/SupplyChain/Stock/Stock";
import StockDetail from "../Pages/SupplyChain/Stock/StockDetails";
import CreateStockOut from "../Pages/SupplyChain/StockOut/CreateStockOut";
import StockOut from "../Pages/SupplyChain/StockOut/StockOut";
import StockOutDetail from "../Pages/SupplyChain/StockOut/StockOutDetail";
import CreateTransferAsset from "../Pages/SupplyChain/TransferAssets/CreateTransferAsset";
import TransferAssetDetail from "../Pages/SupplyChain/TransferAssets/TransferAssetDetail";
import TransferAssets from "../Pages/SupplyChain/TransferAssets/TransferAssets";
import ScrollToTop from "../utility/ScrollToTop";
import MyReimbursementForm from "../Pages/HRM/ReimbursementForm/MyReimbursementForm";
import TeamReimbursementForm from "../Pages/HRM/ReimbursementForm/TeamReimbursementForm";
import ReimbursementDetails from "../Pages/HRM/ReimbursementForm/ReimbursementDetails";
import PaymentTicketReimbursement from "../Pages/Accounts/PaymentTickets/PaymentTicketReimbursement";
import CreateReimbursementForm from "../Pages/HRM/ReimbursementForm/CreateReimbursementForm";
import CreateReimbursement from "../Pages/Accounts/PaymentTickets/CreateReimbursement";
import PaySlipSiteWise from "../Pages/HRM/PaySlip/PaySlipsSiteWise";
import SiteSalaryConfig from "../Pages/HRM/HrmSettings/SiteSalaryConfig/SiteSalaryConfig";
import DebitNote from "../Pages/Accounts/DebitNote/DebitNote";
import PaymentTicketAll from "../Pages/Accounts/PaymentTickets/PaymentTicketAll";
import ManageBulkAtt from "../Pages/HRM/Attendance/ManageBulkAtt";
import PaymentAdvisory from "../Pages/Accounts/Voucher/PaymentAdvisory";
import PaymentAdvisoryDetail from "../Pages/Accounts/Voucher/PaymentAdvisoryDetail";
import UserLogs from "../Pages/HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/UserLogs";
import BudgetRequestDetail from "../Pages/Sites/BudgetRequests/BudgetRquestDetail";
import HowToUse from "../Pages/HowToUse/HowToUse";
import TaskManagement from "../Pages/TaskManagement/TaskManagement";
import ViewCreateSalaryDetails from "../Pages/HRM/Attendance/ViewCreateSalaryDetails";
import TransferRequests from "../Pages/HRM/HrmSettings/TransferRequests";
import OfficeSalaryHead from "../Pages/HRM/HrmSettings/OfficeSalaryHead/OfficeSalaryHead";
import AddOfficeSalaryHead from "../Pages/HRM/HrmSettings/OfficeSalaryHead/AddOfficeSalaryHead";

const CommonRoutes = () => {
  return (
    <BrowserRouter
      basename={import.meta.env.VITE_PUBLIC_URL}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ScrollToTop>
        <Routes>
          <Route element={<ProtectedLoginRoute />}>
            <Route path={RoutesLink.login} element={<Login />} />
            <Route
              path={RoutesLink.forgot_password}
              element={<ForgetPassword />}
            />
            <Route path={RoutesLink.verify_otp} element={<VerifyOtp />} />
            <Route path={RoutesLink.new_password} element={<NewPassword />} />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path={RoutesLink.dashboard} element={<Dashboard />} />
            <Route path={RoutesLink.operations_center} element={<OperationsCenter />} />

            {/* customers */}
            <Route path={RoutesLink.customers} element={<Customers />} />
            <Route path={RoutesLink.add_customer} element={<AddCustomer />} />
            <Route
              path={RoutesLink.customer_detail + "/:id"}
              element={<CustomerDetail />}
            />

            {/* site */}
            <Route path={RoutesLink.sites_OandM} element={<SitesOandM />} />
            <Route path={RoutesLink.sites_project} element={<SitesProject />} />
            <Route path={RoutesLink.add_site} element={<AddSite />} />
            <Route
              path={RoutesLink.site_detail + "/:id"}
              element={<SiteDetail />}
            />
            <Route path={RoutesLink.company} element={<Company />} />
            <Route
              path={RoutesLink.company_detail + "/:id"}
              element={<CompanyDetail />}
            />
            <Route path={RoutesLink.add_company} element={<AddCompany />} />
            <Route path={RoutesLink.assets} element={<Assets />} />
            <Route
              path={RoutesLink.budget_requests}
              element={<BudgetRequests />}
            />
            <Route
              path={RoutesLink.create_budget_request}
              element={<CreateBudgetRequest />}
            />
            <Route
              path={RoutesLink.budget_request_detail + "/:id"}
              element={<BudgetRequestDetail />}
            />
            <Route
              path={RoutesLink.budget_logs + "/:id"}
              element={<BudgetLogs />}
            />
            <Route
              path={RoutesLink.site_salary_head}
              element={<SiteSalaryHead />}
            />
            <Route
              path={RoutesLink.add_site_salary_head}
              element={<AddSiteSalaryHead />}
            />

            {/* HRM Admin */}
            <Route
              path={RoutesLink.attendance_admin}
              element={<AttendanceAdmin />}
            />
            <Route
              path={RoutesLink.attendance_summary}
              element={<AttendanceSummary />}
            />
            <Route
              path={RoutesLink.view_create_salary_details + "/:month"}
              element={<ViewCreateSalaryDetails />}
            />
            <Route
              path={RoutesLink.leave_request}
              element={<AdminLeaveRequest />}
            />
            <Route
              path={RoutesLink.leave_detail + "/:id"}
              element={<LeaveDetail />}
            />
            <Route path={RoutesLink.extra_work} element={<ExtraWork />} />
            <Route path={RoutesLink.ar_request} element={<AdminArRequest />} />
            <Route
              path={RoutesLink.ar_request_detail + "/:id"}
              element={<ArRequestDetail />}
            />
            <Route path={RoutesLink.od_request} element={<AdminOdRequest />} />
            <Route
              path={RoutesLink.add_Od_request}
              element={<AddOdRequest />}
            />
            <Route
              path={RoutesLink.od_request_detail + "/:id"}
              element={<AdminOdRequestDetail />}
            />
            <Route path={RoutesLink.wfh_request} element={<AdminWfhRequest />} />

            {/* HRM User */}
            <Route
              path={RoutesLink.attendance_user}
              element={<AttendanceUser />}
            />
            <Route
              path={RoutesLink.attendance_summary_details + "/:id"}
              element={<AttendanceUser />}
            />
            <Route
              path={RoutesLink.team_attendance}
              element={<TeamAttendance />}
            />
            <Route
              path={RoutesLink.manage_bulk_attendance}
              element={<ManageBulkAtt />}
            />
            <Route
              path={RoutesLink.extra_work_user}
              element={<ExtraWorkUser />}
            />
            <Route
              path={RoutesLink.extra_work_team}
              element={<TeamExtraWork />}
            />
            <Route path={RoutesLink.my_leave} element={<MyLeave />} />
            <Route path={RoutesLink.team_leave} element={<TeamLeave />} />
            <Route path={RoutesLink.my_Ar} element={<UserAr />} />
            <Route path={RoutesLink.team_Ar} element={<TeamAR />} />
            <Route path={RoutesLink.my_od} element={<UserOd />} />
            <Route path={RoutesLink.team_od} element={<TeamOd />} />
            <Route path={RoutesLink.my_wfh} element={<MyWfh />} />
            <Route path={RoutesLink.team_wfh} element={<TeamWfh />} />
            <Route path={RoutesLink.payslip} element={<PaySlip />} />
            <Route path={RoutesLink.my_payslip} element={<MyPaySlip />} />
            <Route
              path={RoutesLink.payslip_site_wise + "/:id"}
              element={<PaySlipSiteWise />}
            />
            <Route path={RoutesLink.holiday} element={<Holiday />} />

            {/* HRM Setting */}
            <Route
              element={
                <ProtectedDepartmentRoute
                  allowedDepartments={["HRM", "Management"]}
                />
              }
            >
              <Route
                path={RoutesLink.office_location}
                element={<OfficeLocation />}
              />
              <Route path={RoutesLink.add_office} element={<AddOffice />} />
              <Route
                path={RoutesLink.shifts}
                element={<ShiftAndTimeConfig />}
              />
              <Route
                path={RoutesLink.add_Shift}
                element={<AddShiftAndTime />}
              />
              <Route
                path={RoutesLink.employee_onboard}
                element={<EmployeeOnBoard />}
              />
              <Route path={RoutesLink.user_logs} element={<UserLogs />} />
              <Route
                path={RoutesLink.add_employee_onboard}
                element={<AddEmployeeOnBoard />}
              />
              <Route path={RoutesLink.salary_head} element={<SalaryHead />} />
              <Route
                path={RoutesLink.add_salary_head}
                element={<AddSalaryHead />}
              />
              <Route
                path={RoutesLink.leave_setting}
                element={<LeaveSetting />}
              />
              <Route
                path={RoutesLink.add_leave_setting}
                element={<AddLeaveSetting />}
              />
              <Route path={RoutesLink.holiday} element={<Holiday />} />
              <Route
                path={RoutesLink.employee_transfer}
                element={<EmployeeTransfer />}
              />
              <Route
                path={RoutesLink.site_salary_config}
                element={<SiteSalaryConfig />}
              />
              <Route
                path={RoutesLink.office_salary_head}
                element={<OfficeSalaryHead />}
              />
              <Route
                path={RoutesLink.add_office_salary_head}
                element={<AddOfficeSalaryHead />}
              />
              <Route
                path={RoutesLink.transfer_requests}
                element={<TransferRequests />}
              />
            </Route>

            <Route
              element={
                <ProtectedDepartmentRoute
                  allowedDepartments={[
                    "HRM",
                    "Solar / Wind",
                    "GSS / TL",
                    "Management",
                  ]}
                />
              }
            >
              <Route
                path={RoutesLink.employee_detail + "/:id"}
                element={<EmployeeDetail />}
              />
            </Route>

            <Route
              element={
                <ProtectedDepartmentRoute
                  allowedDepartments={["SCM", "Management"]}
                />
              }
            >
              <Route
                path={RoutesLink.transfer_assets}
                element={<TransferAssets />}
              />
              <Route
                path={RoutesLink.create_transfer_asset}
                element={<CreateTransferAsset />}
              />
              <Route
                path={RoutesLink.transfer_asset_detail + "/:id"}
                element={<TransferAssetDetail />}
              />
            </Route>

            {/* Supply Chain */}
            <Route
              element={
                <ProtectedDepartmentRoute
                  allowedDepartments={[
                    "SCM",
                    "Solar / Wind",
                    "GSS / TL",
                    "Management",
                  ]}
                />
              }
            >
              <Route path={RoutesLink.purchase} element={<Purchase />} />
              <Route
                path={RoutesLink.create_purchase}
                element={<CreatePurchase />}
              />
              <Route path={RoutesLink.stock} element={<Stock />} />
              <Route
                path={RoutesLink.stock_detail + "/:id"}
                element={<StockDetail />}
              />
              <Route path={RoutesLink.stock_out} element={<StockOut />} />
              <Route
                path={RoutesLink.stock_out_detail + "/:id"}
                element={<StockOutDetail />}
              />
              <Route
                path={RoutesLink.create_stock_out}
                element={<CreateStockOut />}
              />
              <Route
                path={RoutesLink.purchase_request_detail + "/:id"}
                element={<PurchaseRequestDetails />}
              />
              <Route
                path={RoutesLink.purchase_request}
                element={<PurchaseRequest />}
              />
              <Route
                path={RoutesLink.create_purchase_request}
                element={<CreatePurchaseRequest />}
              />
              <Route path={RoutesLink.machinery} element={<Machinery />} />
              <Route
                path={RoutesLink.add_machinery}
                element={<AddMachinery />}
              />
              <Route
                path={RoutesLink.machinery_details + "/:id"}
                element={<MachineryDetails />}
              />

              {/* Supply Chain Setting */}
              <Route path={RoutesLink.vendor_list} element={<VendorList />} />
              <Route path={RoutesLink.add_vendor} element={<AddVendor />} />
              <Route
                path={RoutesLink.vendor_detail + "/:id"}
                element={<VendorDetail />}
              />
              <Route path={RoutesLink.expense_head} element={<ExpenseHead />} />
              <Route
                path={RoutesLink.general_expense_head}
                element={<GeneralExpenseHead />}
              />
              <Route path={RoutesLink.service_type} element={<ServiceList />} />
              <Route path={RoutesLink.item_master} element={<ItemMaster />} />
              <Route path={RoutesLink.grn} element={<GRN />} />
              <Route
                path={RoutesLink.grn_detail + "/:id"}
                element={<GrnDetail />}
              />
            </Route>

            <Route
              element={
                <ProtectedDepartmentRoute
                  allowedDepartments={[
                    "Account",
                    "SCM",
                    "Solar / Wind",
                    "GSS / TL",
                    "Management",
                  ]}
                />
              }
            >
              <Route path={RoutesLink.createGrn} element={<CreateGRN />} />
              <Route
                path={RoutesLink.purchase_order}
                element={<PurchaseOrder />}
              />
              <Route
                path={RoutesLink.purchase_order_detail + "/:id"}
                element={<PurchaseOrderDetail />}
              />
            </Route>

            {/* Accounts */}
            <Route
              element={
                <ProtectedDepartmentRoute
                  allowedDepartments={["Account", "Management"]}
                />
              }
            >
              <Route path={RoutesLink.work_order} element={<WorkOrder />} />
              <Route
                path={RoutesLink.add_work_order}
                element={<AddWorkOrder />}
              />
              <Route
                path={RoutesLink.work_order_detail + "/:id"}
                element={<WorkOrderDetail />}
              />
              <Route path={RoutesLink.invoice} element={<Invoice />} />
              <Route
                path={RoutesLink.invoice_detail + "/:id"}
                element={<InvoiceDetail />}
              />
              <Route path={RoutesLink.tds_ledger} element={<TdsLedger />} />
              <Route
                path={RoutesLink.tds_detail + "/:id"}
                element={<TdsDetail />}
              />
              <Route
                path={RoutesLink.create_invoice}
                element={<CreateInvoice />}
              />
              <Route path={RoutesLink.day_book} element={<DayBook />} />
              <Route
                path={RoutesLink.payment_advisory}
                element={<PaymentAdvisory />}
              />
              <Route
                path={RoutesLink.payment_advisory_detail + "/:id"}
                element={<PaymentAdvisoryDetail />}
              />
              <Route
                path={RoutesLink.vendor_ledger}
                element={<VendorLedger />}
              />
              <Route
                path={RoutesLink.vendor_ledger_detail + "/:id"}
                element={<VendorLedgerDetail />}
              />
              <Route
                path={RoutesLink.customer_ledger}
                element={<CustomerLedger />}
              />
              <Route
                path={RoutesLink.customer_ledger_detail + "/:id"}
                element={<CustomerLedgerDetail />}
              />
              <Route
                path={RoutesLink.payment_overview}
                element={<PaymentOverview />}
              />
              <Route path={RoutesLink.debit_note} element={<DebitNote />} />
            </Route>

            {/* Common */}
            {/* //protected routing remaining for salary ticket section */}
            <Route
              path={RoutesLink.salary_ticket}
              element={<SalaryTickets />}
            />
            <Route
              path={RoutesLink.salary_ticket_detail + "/:id"}
              element={<SalaryTicketDetails />}
            />
            <Route
              path={RoutesLink.create_salary_ticket}
              element={<CreateSalaryTicket />}
            />

            <Route
              path={RoutesLink.payment_tickets_all}
              element={<PaymentTicketAll />}
            />
            <Route
              path={RoutesLink.payment_ticket_against_po}
              element={<PaymentTicketAgainsPo />}
            />
            <Route
              path={RoutesLink.payment_ticket_general}
              element={<PaymentTicketGeneral />}
            />
            <Route
              path={RoutesLink.payment_ticket_reimbursement}
              element={<PaymentTicketReimbursement />}
            />
            <Route
              path={RoutesLink.payment_tickets_details + "/:name/:id"}
              element={<PaymentTicketDetails />}
            />
            <Route
              path={RoutesLink.create_against_po}
              element={<CreateAgainstPO />}
            />
            <Route
              path={RoutesLink.create_general}
              element={<CreateGeneral />}
            />
            <Route
              path={RoutesLink.create_reimbursement}
              element={<CreateReimbursement />}
            />
            <Route path={RoutesLink.profile} element={<UserProfile />} />
            <Route
              path={RoutesLink.update_profile}
              element={<UpdateProfile />}
            />
            <Route
              path={RoutesLink.notifications}
              element={<Notifications />}
            />
            <Route
              path={RoutesLink.my_Reimbursement_Form}
              element={<MyReimbursementForm />}
            />
            <Route
              path={RoutesLink.team_Reimbursement_Form}
              element={<TeamReimbursementForm />}
            />
            <Route
              path={RoutesLink.team_Reimbursement_Form + "/:id"}
              element={<MyReimbursementForm />}
            />
            <Route
              path={RoutesLink.create_Reimbursement_Form}
              element={<CreateReimbursementForm />}
            />
            <Route
              path={RoutesLink.reimbursement_details + "/:id"}
              element={<ReimbursementDetails />}
            />
            <Route path={RoutesLink.task_management} element={<TaskManagement />} />
            <Route path={RoutesLink.how_to_use} element={<HowToUse />} />
            {/* <Route path={RoutesLink.office_task_management} element={<OfficeTaskManagement />} /> */}
          </Route>
          {/* Public */}
          <Route path={RoutesLink.no_internet} element={<NoInternet />} />
          <Route
            path={RoutesLink.under_development_page}
            element={<UnderDevelopmentPage />}
          />
          <Route path={RoutesLink.forbidden_403} element={<Forbidden403 />} />
          <Route path={RoutesLink.privacy_policy} element={<PrivacyPolicy />} />
          <Route
            path={RoutesLink.under_maintainance}
            element={<UnderMaintenancePage />}
          />
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
};
export default CommonRoutes;
